<template>
  <section class="section">
    <div class="home container">
      <div class="columns">
        <div class="column content">
          <h1>JHU Broadcast Mentions - Expert</h1>
          <transition name="fade" mode="out-in">
            <div class="loading" v-if="loading === true">
              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="columns">
        <div class="column content is-3">
          <label for="">
            <h5>Select Date</h5>
          </label>
          <div class="field has-addons has-addons-centered">
            <div class="control">
              <a class="button" @click="moveDay('back')">
                &#10563;
              </a>
            </div>
            <div class="control">
              <v-date-picker @input="getit(date)" v-model="date" is-dark color="teal" />
            </div>
            <div class="control">
              <a class="button" @click="moveDay('fwd')">
                &#10562;
              </a>
            </div>
          </div>
        </div>
        <div class="column content is-6">
          <label for=""><h5>Filter</h5></label>
          <div class="field has-addons">
            <p class="control">
              <span class="select">
                <select v-model="colSearch" @change="resetFilter()">
                  <option>alias</option>
                  <option>broadcastType</option>
                  <option>affiliate</option>
                  <option>callSign</option>
                  <option>marketCountry</option>
                  <option>marketName</option>
                  <option>title</option>
                  <option>ccText</option>
                </select>
              </span>
            </p>
            <p class="control is-expanded">
              <input
                type="text"
                class="input"
                v-model="term"
                placeholder="Start typing..."
                @keyup="search(term)"
              />
            </p>
          </div>
        </div>
        <div class="column content">
          <label for=""><h5>Tools</h5></label>
          <div class="end">
            <button class="button is-primary smbut" @click="downloadCSV(date)">Download CSV</button>
            <!-- <button class="button is-warning smbut" @click="refetch(date)">
              Refetch Date
            </button> -->
            <button class="button is-warning smbut" @click.prevent="logOut()" v-if="loggedIn">
              Sign Out
            </button>
          </div>
        </div>
      </div>
      <VueTabulator ref="table" v-model="snapshot" :options="options" class="table-striped" />
      <br /><br />
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase/app'
import '@firebase/firestore'
//TODO: maybe not needed
//import moment from 'moment'
//import LZString from 'lz-string'

var config = {
  apiKey: 'AIzaSyDMAznaWJM5RGZH008waTHgU09p1sbWcTw',
  authDomain: 'critical-mention.firebaseapp.com',
  databaseURL: 'https://critical-mention.firebaseio.com',
  projectId: 'critical-mention',
  storageBucket: 'critical-mention.appspot.com',
  messagingSenderId: '290083127751',
  appId: '1:290083127751:web:4c63d9bf75d61b9f3619e2',
}

// Initialize Firebase
!firebase.apps.length ? firebase.initializeApp(config) : ''
const db = firebase.firestore()

export default {
  name: 'Home',
  data() {
    return {
      loading: false,
      term: '',
      colSearch: 'callSign',
      date: this.$moment()
        .subtract('1', 'day')
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate(),
      snapshot: [],
      snap: [],
      options: {
        //layout: 'fitColumns',
        //height: '800px',
        //responsiveLayout: true,
        resizableRows: false,
        layout: 'fitDataFill',
        pagination: 'local',
        paginationSize: 40,
        paginationSizeSelector: [40, 80, 250, 500, 1000],
        columns: [
          {
            title: 'Alias',
            field: 'alias',
            sorter: 'string',
            bottomCalc: 'count',
          },
          {
            title: 'BroadcastType',
            field: 'broadcastType',
            sorter: 'string',
            width: 90,
          },
          {
            title: 'Affiliate',
            field: 'affiliate',
            sorter: 'string',
          },
          {
            title: 'CallSign',
            field: 'callSign',
            sorter: 'string',
          },
          {
            title: 'MarketCountry',
            field: 'marketCountry',
            sorter: 'string',
          },
          {
            title: 'MarketName',
            field: 'marketName',
            sorter: 'string',
          },
          {
            title: 'Time (EST)',
            field: 'timeString',
            width: 125,
          },
          {
            title: 'Title',
            field: 'title',
            sorter: 'string',
          },
          {
            title: 'Audience',
            field: 'numHouseholds',
            sorter: 'number',
            bottomCalc: 'sum',
          },
          {
            title: 'adValue',
            field: 'adValue',
            sorter: 'number',
          },
          {
            title: 'Wordplay URL',
            field: 'mediaUrl',
            sorter: 'string',
            formatter: 'link',
            width: 300,
            formatterParams: {
              target: '_blank',
            },
          },
          {
            title: 'ccText',
            field: 'ccText',
            formatter: 'plaintext',
            width: 300,
          },
        ],
      },
    }
  },
  mounted() {
    // On mount, this is auto called by table init
    // this.getit(this.date)
    this.setSort()
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
  },
  methods: {
    moveDay(dir) {
      let d = this.date
      if (dir === 'fwd') {
        this.date = this.$moment(d)
          .add(1, 'day')
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate()
      } else if (dir === 'back') {
        this.date = this.$moment(d)
          .subtract(1, 'day')
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate()
      }
    },
    search(term) {
      let col = this.colSearch
      if (term.length >= 1) {
        let tabs = this.$refs.table.getInstance()
        tabs.setFilter(col, 'like', term)
      } else {
        let tabs = this.$refs.table.getInstance()
        tabs.clearFilter()
      }
    },
    resetFilter() {
      this.term = ''
      let tabs = this.$refs.table.getInstance()
      tabs.clearFilter()
    },
    downloadCSV(date) {
      let tabs = this.$refs.table.getInstance()
      let day = this.$moment(date).format('YYYY-MM-DD').toString()
      tabs.download('csv', day + '_jhu-broadcast.csv')
    },
    refetch(date) {
      let day = this.$moment(date).format('YYYY-MM-DD')
      localStorage.removeItem(day)
      this.getit(date)
    },
    setSort() {
      let tabs = this.$refs.table.getInstance()
      tabs.setSort('timeString', 'desc')
    },
    getit(date) {
      this.loading = true
      // Get UTC offset for browsers timezone in minutes
      let tz = new Date().getTimezoneOffset()
      // Divide by 60 to get UTC offset in hours
      let offset = tz / 60
      // find difference between browsers offset and servers offset in hours
      // This 5 comes from the fact that i am saving the Date field in UTC timestamp. UTC = 5am
      let finalOffset = -(offset - 5)
      // add the hour offset to the browsers generated date
      let day = this.$moment(date).add(finalOffset, 'hour').toDate()
      //  When querying, firebase converts the input time to UTC
      // console.log(day.valueOf())
      // Output: the final date in Server's timezone to use for query
      let dayKey = this.$moment(date).format('YYYY-MM-DD')
      // localstorage cache replaced with store
      // let cache,
      //   isStored = localStorage.getItem(dayKey)
      // // If storage exists,decompress the string and parse it, else cache is null
      // if (isStored) {
      //   let c = LZString.decompressFromUTF16(isStored)
      //   cache = JSON.parse(c)
      // } else {
      //   cache = null
      // }
      let cache = this.$store.state.cache[dayKey]
      if (cache && cache.length) {
        this.snapshot = cache
        this.loading = false
      } else {
        this.snapshot = []
        let that = this
        let ref = db.collectionGroup('clips_jhu').where('date', '==', day)
        ref
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              that.snapshot.push(doc.data())
            })
            this.$store.commit('addTo', { day: dayKey, data: this.snapshot })
            this.loading = false
            // localstorage cache replaced with store
            // Stringify object, compress, and save
            //let s = JSON.stringify(this.snapshot)
            //let compressed = LZString.compressToUTF16(s)
            //localStorage.setItem(dayKey, compressed)
          })
          .catch((err) => {
            alert(err)
            this.loading = false
          })
      }
    },
    logOut() {
      let that = this
      firebase
        .auth()
        .signOut()
        .then(() => {
          that.$store.commit('setLogin', false)
          that.$router.push('/')
        })
        .catch((error) => {
          alert(error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loading {
  position: fixed;
  left: 50%;
  top: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: flex;
  justify-content: center;
  padding-top: 183px;
  background: rgba(255, 255, 255, 0.68);
}

.select select:not([multiple]) {
  padding-right: 2em;
  font-size: 13px;
  height: 40px;
}

.content {
  margin-bottom: 0.5rem !important;
}

.smbut {
  font-size: 13px !important;
  height: 40px !important;
  margin-left: 10px !important;
}

.end {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  @media (max-width: 768px) {
    justify-content: center;
  }
}

.tabulator {
  font-size: 11px;
}

.tabulator-row .tabulator-cell {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 4px;
  border-right: 1px solid #ececec;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabulator-row {
  position: relative;
  box-sizing: border-box;
  min-height: 22px;
  background-color: #fff;
}

// .tabulator .tabulator-header .tabulator-calcs-holder .tabulator-row {
//   background: #333 !important;
// }

.tabulator-calcs-holder .tabulator-row {
  color: green !important;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
  padding-right: 10px;
}

.tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row {
  color: #a0ed3f !important;
  background: rgb(26, 26, 26) !important;
  .tabulator-cell {
    border-right: 1px solid #464646 !important;
  }
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-arrow {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #bbb;
}

.tabulator
  .tabulator-header
  .tabulator-col.tabulator-sortable[aria-sort='none']
  .tabulator-col-content
  .tabulator-arrow {
  border-top: none;
  border-bottom: 4px solid #bbb;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  padding: 0.5rem 0.5rem 0.5rem;
}

.signout {
  display: block;
  font-size: 11px;
  margin-top: 8px;
  position: absolute;
  top: -20px;
  right: 11px;
}

.field.has-addons .button {
  background: #01d1b2;
  padding: 2px;
  width: 25px;
  color: #fff;
  border: none;
  font-weight: bold;
  border-radius: 6px;
  z-index: 999;
}
.field.has-addons .button:hover {
  background: #6ee0cf;
}
.field.has-addons .control:not(:last-child) {
  margin-right: 0;
}
input.vc-text-base {
  height: 40px;
  border-width: 1px;
  border-radius: 0;
}
.tabulator .tabulator-footer .tabulator-page {
  display: inline-block;
  margin: 0;
  margin-top: 5px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-right: none;
  background: rgba(255, 255, 255, 0.2);
  color: #1a1a1a;
  font-family: inherit;
  font-weight: bold;
  font-size: inherit;
}
.tabulator .tabulator-footer .tabulator-page.active {
  border-color: #01d1b2;
  background-color: #01d1b2;
  color: #fff;
}
.tabulator .tabulator-footer .tabulator-page:not(.disabled):hover {
  border-color: #6ee0cf;
  background-color: #6ee0cf;
  color: #fff;
}
select.tabulator-page-size {
  margin-right: 10px;
  margin-left: 10px;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #ffdd57;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
